"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-section" className="relative w-full py-32 md:py-48 lg:py-56 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_field_hero_bg.png)] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-background/30 backdrop-blur-[1px]"></div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-default text-foreground tracking-tight drop-shadow-sm">
          Photography Sessions
        </h1>
      </div>
    </section>;
}